import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import PrimaryTransportationTable from "./SFGBomTable";
import btnDownloadIcon from "../../../Assests/download-icon.svg";
import btnSaveIcon from "../../../Assests/Save-btn.svg";
import {
  EditProductTableSuccess,
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
  enableEditFilter,
} from "../../../Redux/Actions/InputData";
import { postRequest, putRequest } from "../../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  BULK_EDIT_MANUFACTURING_MASTER_TABLE_API,
  DISPLAY_MANUFACTURING_MASTER_1_TABLE_API,
  DOWNLOAD_MANUFACTURING_MASTER_1_TABLE_API,
  LONG_FACILITY_MASTER_GET_API,
  LONG_GETALL_SFGBOM,
  LONG_PRIMARY_TRANSPORTATION_DOWNLOAD_API,
  LONG_PRIMARY_TRANSPORTATION_GET_API,
  LONG_UPDATE_BULK_EDIT_SFGB_API,
  LONG__SFGBOM_DOWNLOAD_API,
  UPDATE_BULK_PRI_TRA_BY_IDS,
  UPDATE_PROCESSING_PLANTS_BY_IDS,
  VIEW_MANUFACTURING_MASTER_1_TABLE_API,
} from "../../../Utils/Config";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import axios from "axios";
import FileSaver from "file-saver";
import "./style.css";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertProps } from "@mui/material/Alert";
import SFGBomTable from "./SFGBomTable";

import AddRowButton from "../../../Components/Common/AddRowButton";
import DeleteRowsButton from "../../../Components/Common/DeleteRowsButton";
import ConfirmationDialog from "../../../Components/Common/ConfirmationDialog";

function SFGBom(props: any) {
  const childRef: any = useRef();
  const dispatch: any = useDispatch();

  const [rowsData, setRows] = React.useState<any[]>([]);
  const [isProcessed, setIsProcessed] = React.useState(false);

  // on change values for filters

  const [selectPackagingPlantCode, setSelectPackagingPlantCode] =
    useState<any>("");
  const [selectFgCode, setselectFgCode] = useState<any>("");
  const [selectSFGType, setselectSFGType] = useState<any>("");
  const [selectSFGCode, setselectSFGCode] = useState<any>("");
  const [selectSFGDescription, setselectSFGDescription] = useState<any>("");

  /// options for filters
  const [packagingPlantCodeOptions, setPackagingPlantCodeOptions] =
    React.useState([]);
  const [fgCodeOptions, setfgCodeOptions] = useState<any>([]);
  const [sfgDescriptionOptions, setsfgDescriptionOptions] = useState<any>([]);
  const [sfgCodeOption, setsfgCodeOption] = useState<any>([]);
  const [sfgTypeOption, setsfgTypeOption] = useState<any>([]);

  const [lineOptions, setLineOptions] = useState<any>([]);
  const [getEditedValue, setEditedValue] = useState<any>([]);
  const [open, setOpen] = React.useState(false);

  const [filterRequest, setFilterRequest] = React.useState([
    { key: "processing_Plant_Code", value: "" },
    { key: "sfG_Code", value: "" },
    { key: "sfG_Description", value: "" },
    { key: "rM_Code", value: "" },

    // { key: "sfG_PM_Code", value: "" },
  ]);

  const sortedPackagingPlantCodeNames = packagingPlantCodeOptions?.sort(
    (a: any, b: any) =>
      a?.processing_Plant_Code.localeCompare(b?.processing_Plant_Code)
  );

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deletedRows, setDeletedRows] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [isActionEnabled, setIsActionEnabled] = useState(false);
  const handleSelectionChange = (newSelection: any[]) => {
    setSelectedRows(newSelection);
    setIsActionEnabled(newSelection.length > 0);
  };

  var PPC = 0;
  var SFGC = 0;
  var SFGD = 0;
  var RMC = 0;
  // var SFGT = 0;
  // var SFGC = 0;

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId
  );

  /**Redux state */
  const selectedUsecaseeId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId
  );

  const isEditPopup = useSelector(
    (state: any) => state.InputDataReducers.editPopupFlage
  );

  const selectedFolderData = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderData
  );

  let folderModuleName = selectedFolderData?.folder?.slice(0, 7);

  const handleSelectPackagingPlantCode = (event: any) => {
    setselectFgCode("");
    setselectSFGType("");
    setselectSFGDescription("");

    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    const {
      target: { value },
    } = event;
    setSelectPackagingPlantCode(value);
    filterRequest[0].value = value;
    callTableGridApi();
    PPC = 1;
    SFGC = 0;
    SFGD = 0;
    RMC = 0;
  };

  const handleSelectFgCode = (event: any) => {
    setselectSFGType("");
    setselectSFGDescription("");
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    // filterRequest[3].value = ''
    const {
      target: { value },
    } = event;
    setselectFgCode(value);
    filterRequest[1].value = value;
    callTableGridApi();
    PPC = 1;
    SFGC = 1;
    SFGD = 0;
    RMC = 0;
  };

  const handleRMCode = (event: any) => {
    // filterRequest[3].value = ''
    const {
      target: { value },
    } = event;
    setselectSFGType(value);
    filterRequest[3].value = value;
    callTableGridApi();
    PPC = 1;
    SFGC = 1;
    SFGD = 1;
    RMC = 1;
  };

  // const handleChangeSelectSFGCode = (event: any) => {
  //   PPC = 1;
  //   FGC = 1;
  //   SFGT = 1;
  //   SFGC = 1;
  //   const {
  //     target: { value },
  //   } = event
  //   setselectSFGCode(value)
  //   filterRequest[3].value = value
  //   callTableGridApi()
  // }
  const handleSfgDesc = (event: any) => {
    setselectSFGType("");
    filterRequest[3].value = "";
    const {
      target: { value },
    } = event;
    setselectSFGDescription(value);
    filterRequest[2].value = value;
    callTableGridApi();
    PPC = 1;
    SFGC = 1;
    SFGD = 1;
    RMC = 0;
  };

  const [tableName, setTableName] = useState<any>("tblScenario_SFGBOM_LT");

  useEffect(() => {
    if (folderModuleName === "module2") {
      setTableName("tblScenario_SFGBOM_LT_Module2");
      getfiltersApi("tblScenario_SFGBOM_LT_Module2");
    } else if (folderModuleName === "module3") {
      setTableName("tblScenario_SFGBOM_LT_Module3");
      getfiltersApi("tblScenario_SFGBOM_LT_Module3");
    } else if (folderModuleName === "module4") {
      setTableName("tblScenario_SFGBOM_LT_Module4");
      getfiltersApi("tblScenario_SFGBOM_LT_Module4");
    } else if (folderModuleName === "module5") {
      setTableName("tblScenario_SFGBOM_LT_Module5");
      getfiltersApi("tblScenario_SFGBOM_LT_Module5");
    } else if (folderModuleName === "module6") {
      setTableName("tblScenario_SFGBOM_LT_Module6");
      getfiltersApi("tblScenario_SFGBOM_LT_Module6");
    } else {
      setTableName("tblScenario_SFGBOM_LT");
      getfiltersApi("tblScenario_SFGBOM_LT");
    }
  }, [folderModuleName, selectedScenarioId]);

  console.log(folderModuleName, tableName, "folderModuleName");

  const handleDownload = (e: any) => {
    downloadXLSFile();
  };

  const downloadXLSFile = async () => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    const requestParam = {
      usecaseId: 0,
      category_id: 0,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: tableName,
      time_period: "string",
      filter: filterList,
    };
    // const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "filter": filterList };
    const urls = API_BASE_URL + LONG__SFGBOM_DOWNLOAD_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response: any) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  const callTableGridApi = (resetfilter?: any) => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    console.log(selectedScenarioId, "scenario2");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId
        : selectedScenarioId;
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      time_period: "",
      table: tableName,
      filter: filterList,
    };

    console.log(requestParam, "params");
    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + LONG_GETALL_SFGBOM;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    console.log("urlsss", urls);
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setIsProcessed(true);
          setRows(response.data);
          if (PPC === 0)
            setPackagingPlantCodeOptions(
              loadPackagingPlantCodeOptions(response.data)
            );
          if (SFGD === 0) {
            setsfgDescriptionOptions(loadSFGDescOption(response.data));
          }
          if (SFGC === 0) {
            setfgCodeOptions(loadFgCodeOption(response.data));
          }
          if (RMC === 0) {
            setsfgTypeOption(loadSFGTypeOption(response.data));
          }
          // if (SFGC === 0) {
          //   setsfgCodeOption(loadSFGCodeOptions(response.data))
          // }
          dispatch(ViewProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const loadPackagingPlantCodeOptions = (data: any) => {
    const packagingPlantCodeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = packagingPlantCodeOptions.find((obj: any) => {
        return obj.processing_Plant_Code === item.processing_Plant_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        packagingPlantCodeOptions.push({
          id: item.id,
          processing_Plant_Code: item.processing_Plant_Code,
        });
      }
    });
    return packagingPlantCodeOptions;
  };

  const loadFgCodeOption = (data: any) => {
    const fgCodeOption: any = [];
    data.map((item: any) => {
      const filteredItem = fgCodeOption.find((obj: any) => {
        return obj.sfG_Code === item.sfG_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        fgCodeOption.push({
          id: item.id,
          sfG_Code: item.sfG_Code,
        });
      }
    });
    return fgCodeOption;
  };
  const loadSFGDescOption = (data: any) => {
    const sfgDescOption: any = [];
    data.map((item: any) => {
      const filteredItem = sfgDescOption.find((obj: any) => {
        return obj.sfG_Description === item.sfG_Description;
      });
      if (filteredItem === undefined || filteredItem == null) {
        sfgDescOption.push({
          id: item.id,
          sfG_Description: item.sfG_Description,
        });
      }
    });
    return sfgDescOption;
  };

  const loadSFGTypeOption = (data: any) => {
    const sFGTypeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = sFGTypeOptions.find((obj: any) => {
        return obj.rM_Code === item.rM_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        sFGTypeOptions.push({
          id: item.id,
          rM_Code: item.rM_Code,
        });
      }
    });
    return sFGTypeOptions;
  };

  const loadSFGCodeOptions = (data: any) => {
    const sfgCodeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = sfgCodeOptions.find((obj: any) => {
        return obj.sfG_PM_Code === item.sfG_PM_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        sfgCodeOptions.push({
          id: item.id,
          sfG_PM_Code: item.sfG_PM_Code,
        });
      }
    });
    return sfgCodeOptions;
  };

  const getfiltersApi = (tableeName?: string) => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      time_period: "",
      table: tableeName,
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
    };

    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + LONG_GETALL_SFGBOM;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          console.log(response.data, "response");
          setRows(response.data);
          setPackagingPlantCodeOptions(
            loadPackagingPlantCodeOptions(response.data)
          );
          setfgCodeOptions(loadFgCodeOption(response.data));
          setsfgDescriptionOptions(loadSFGDescOption(response.data));
          setsfgTypeOption(loadSFGTypeOption(response.data));
          setsfgCodeOption(loadSFGCodeOptions(response.data));
        }
      })
      .catch((error) => {
        dispatch(ViewProductTableError(error));
      });
  };

  // useEffect(() => {
  //   //callTableGridApi()
  //   getfiltersApi()
  // }, [selectedFolderId, selectedScenarioId])

  const handleRestoreClicked = (e: any) => {
    setSelectPackagingPlantCode("");
    setselectFgCode("");
    setselectSFGType("");
    setselectSFGDescription("");
    filterRequest[0].value = "";
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    callTableGridApi();
  };

  // bulk edit

  const handleClearEditData = (val: any) => {
    console.log(val, "edited array");
  };

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable
  );

  const handleFetchEditData = (val: any) => {
    setEditedValue(val);
  };

  const handleEditSave = (e: any) => {
    const requiredFields = [
      "processing_Plant_Code",
      "processing_Plant_Description",
      "sfG_Code",
      "sfG_Description",
      "rM_Code",
      "rM_Description",
      "boM_Perc",
    ];
    const allMissingFields = new Set<string>();
    getEditedValue.forEach((row: any) => {
      requiredFields.forEach((field) => {
        const value = row[field];
        if (value === undefined || value === null || value === "") {
          // Convert field name to readable format
          const fieldName = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());
          allMissingFields.add(fieldName);
        }
      });
    });

    if (allMissingFields.size > 0) {
      // Convert Set to Array and join
      const missingFieldsList = Array.from(allMissingFields).join(", ");

      setSnackbar({
        children: `Please fill the required fields: ${missingFieldsList}`,
        severity: "error",
      });
      return; // Prevent the save operation
    }

    handleClickOpen();
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddRow = () => {
    setRows((prev: any) => {
      const emptyRow = {
        id: new Date().getTime(),
        folder_Id: selectedFolderId,
        scenario_id: selectedScenarioId,
        processing_Plant_Code: "",
        processing_Plant_Description: "",
        sfG_Code: "",
        sfG_Description: "",
        rM_Code: "",
        rM_Description: "",
        boM_Perc: 0,
        isNew: true,
      };
      return prev.length > 0 ? [...prev, emptyRow] : prev;
    });
  };

  const handleDeleteRows = () => {
    if (!selectedRows.length) return;
    setIsDeleteConfirmOpen(true);
  };

  const handleConfirmDeleteRows = () => {
    const updatedRows: any[] = [];
    const rowsToDelete: any[] = [];

    rowsData.forEach((row: any) => {
      if (selectedRows.includes(row.id)) {
        const updated = {
          ...row,
          folder_id: 0,
          folder_Id: 0,
          scenario_id: 0,
          isDelete: true,
        };
        rowsToDelete.push(updated);
      } else {
        updatedRows.push(row);
      }
    });

    setRows(updatedRows);

    if (rowsToDelete.length > 0) {
      // Store deleted rows separately
      setDeletedRows((prev: any[]) => [...prev, ...rowsToDelete]);

      setIsDeleteConfirmOpen(false);
      setSelectedRows([]);
      setIsActionEnabled(false);

      const dataToSave =
        getEditedValue && getEditedValue.length > 0
          ? [
              ...getEditedValue.filter(
                (row: any) => row && Object.keys(row).length > 0
              ),
              ...rowsToDelete,
            ]
          : rowsToDelete;

      handleAgree(dataToSave, "Record deleted successfully");
    } else {
      setIsDeleteConfirmOpen(false);
    }
  };

  const handleAgree = (dataToSave: any[], successMessage: string) => {
    const transformedRows = dataToSave.map((row: any) => {
      if (row.isNew) {
        const { isNew, ...rest } = row;
        rest.id = 0;
        return rest;
      } else if (row.isDelete) {
        const { isDelete, ...rest } = row;
        rest.folder_id = 0;
        rest.Scenario_Id = 0;
        return rest;
      }

      return row;
    });
    const urls = API_BASE_URL + LONG_UPDATE_BULK_EDIT_SFGB_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };

    putRequest(urls, transformedRows, header, {})
      .then((response) => {
        if (response.status == 200) {
          callTableGridApi();
          setSnackbar({
            children: successMessage,
            severity: "success",
          });
          handleClose();
          childRef?.current?.ClearEditedData();
          dispatch(EditProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        setSnackbar({
          children: "Something went wrong please try again!",
          severity: "error",
        });
        handleClose();
      });
    // setTimeout(() => {
    //   props?.onClose()
    // }, 200)
  };

  // bulk edit

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);
  const uniqueSFGs: any =
    rowsData &&
    rowsData.reduce((acc: any, { id, sfG_Description }: any) => {
      if (!acc.some((item: any) => item.sfG_Description === sfG_Description)) {
        acc.push({ id: "sfgDesc-" + id, sfG_Description });
      }
      return acc;
    }, []);
  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="Dialogbox-display"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="responsive-dialog-title-txt"
        >
          {"Confirmation for Edit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="md-alert-clr">
            {getEditedValue.length > 0
              ? "Do you want to submit the edited SFG BOM table data?"
              : "Please Edit any value to save!"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {getEditedValue.length > 0 ? (
            <>
              <Button className="modal-btn-b" autoFocus onClick={handleClose}>
                No
              </Button>
              <Button
                className="modal-btn-b"
                onClick={() =>
                  handleAgree(getEditedValue, "Successfully saved")
                }
                autoFocus
              >
                Yes
              </Button>
            </>
          ) : (
            <Button className="modal-btn-b" autoFocus onClick={handleClose}>
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onConfirm={handleConfirmDeleteRows}
        title="Confirmation for Delete"
        page="Shift And Changeover"
        confirmText="Yes"
        cancelText="No"
        fullScreen={fullScreen}
      />
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>SFG BOM</h3>
          </div>
          <div className="filters">
            <span title="Reset">
              <RestoreOutlinedIcon
                className="restoreIcon"
                onClick={(e) => handleRestoreClicked(e)}
              />
            </span>
            <AddRowButton
              isEditEnabled={isEditEnabled && !isActionEnabled}
              handleAddRow={handleAddRow}
            />
            <DeleteRowsButton
              isEditEnabled={isEditEnabled && isActionEnabled}
              handleDeleteRows={handleDeleteRows}
            />
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                <Select
                  id="simple-select-1"
                  value={selectPackagingPlantCode}
                  placeholder="Select Processing Plant Code"
                  onChange={handleSelectPackagingPlantCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Processing Plant Code</em>
                  </MenuItem>
                  {sortedPackagingPlantCodeNames?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.processing_Plant_Code}>
                        {d.processing_Plant_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                <Select
                  id="simple-select-2"
                  value={selectFgCode}
                  placeholder="Select Demand Location Code"
                  onChange={handleSelectFgCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>SFG Code</em>
                  </MenuItem>
                  {fgCodeOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.sfG_Code}>
                        {d.sfG_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                <Select
                  id="simple-select-4"
                  value={selectSFGDescription}
                  placeholder="Select Basepack"
                  onChange={handleSfgDesc}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>SFG Description</em>
                  </MenuItem>
                  {sfgDescriptionOptions?.length > 0
                    ? uniqueSFGs?.map((d: any) => {
                        return (
                          <MenuItem key={d.id} value={d.sfG_Description}>
                            {d.sfG_Description}
                          </MenuItem>
                        );
                      })
                    : ""}
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Product Code</InputLabel> */}
                <Select
                  id="simple-select-2"
                  value={selectSFGType}
                  placeholder="Select Product Code"
                  onChange={handleRMCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>RM Code</em>
                  </MenuItem>
                  {sfgTypeOption?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.rM_Code}>
                        {d.rM_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            {isEditEnabled && isEditPopup && (
              <FormControl fullWidth>
                <div
                  className="content-save-btn"
                  onClick={(e) => handleEditSave(e)}
                >
                  <img src={btnSaveIcon} alt="" /> <span> Save</span>
                </div>
              </FormControl>
            )}

            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className="content-download-btn"
                  onClick={(e) => handleDownload(e)}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <div>
        <SFGBomTable
          ref={childRef}
          isProcessed={isProcessed}
          rowsData={rowsData}
          handleGetEditData={handleFetchEditData}
          handleClearEditData={handleClearEditData}
          setRows={setRows}
          handleSelectionChange={handleSelectionChange}
          selectedRows={selectedRows}
        />
        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </div>
    </>
  );
}

export default SFGBom;
